import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { AppManagerService } from '@services/app/app.manager.service';

@Injectable({
  providedIn: 'root'
})
export class DeactivateGuardService implements CanDeactivate<MSafeAny> {
  constructor(private appManagerService: AppManagerService) {}

  canDeactivate(): boolean {
    return !this.appManagerService.isBlock();
  }
}
